// extracted by mini-css-extract-plugin
export default {"block":"Kc","image":"Lc","item":"Mc","error":"Nc"};